import { GET_PREPARATIONS_ENSEIGNE } from "../actions/preparations.actions";

const initialState = {};

export default function preparationsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PREPARATIONS_ENSEIGNE:
      return action.payload;
    default:
      return state;
  }
}
